import { envConfig } from "@env/env-config";
import { ICartRestService } from "@modules/cart/rest/cart-rest";
import { ISocialLoginRestService, thirdOAuthType } from "@modules/partner/rest/social-login/social-login-rest";
import { LoginObjectTreeService } from "../login/login-object-tree.service";
import { AnonymousPageController } from "@modules/basic/page";
import { IAnonymousRestService } from "@modules/user/rest/anonymous-rest";
import { IMessageDialog } from "@qpUIs/qp-message-dialog/qp-message-dialog.interface";
import { UrlUtil } from "@core/utils";

type fbUser = {
    isUserLoggedIn: boolean,
    token: string,
    userId: string
}
type socialNetworkAction = "login" | "regist";
type socialNetwork = "google" | "facebook";
export type jumpParams = {
    prePath: string;
}

export class SocialLoginController extends AnonymousPageController implements angular.IController {

    public static readonly $inject: Array<string> = [
        "$q", "$scope", "$timeout", "pageContext",
        "socialLoginRestService", "$objectTree", "cartRestService",
        "runtimeContext", "anonymousRestService", "$injector", "qpMessageDialog", "$translate"
    ];

    // 用于google第三方登录
    private tokenClient: google.accounts.oauth2.TokenClient;

    private action: socialNetworkAction;

    private thirdAccessToken: string;

    private socialNetwork: socialNetwork;

    private socialUserNickname?: string;

    private socialUserEmail?: string;

    private socialRegisterForm: angular.IFormController;

    private isSignUping: boolean = false;

    public readonly rootPath: string;

    public privacy: boolean;

    // 本地缓存localSagePrivacyPolicy状态
    private cachePrivacyPolicy: boolean | undefined;
    // 购物车、结算页面跳转路径
    private jumpPath?: string;

    constructor(
        public $q: angular.IQService,
        public $scope: angular.IScope,
        public $timeout: angular.ITimeoutService,
        public pageContext: qpmn.main.IPageContext,
        public socialLoginRestService: ISocialLoginRestService,
        public $objectTree: LoginObjectTreeService,
        public cartRestService: ICartRestService,
        public runtimeContext: qpmn.main.IRuntimeContext,
        public anonymousRestService: IAnonymousRestService,
        public $injector: angular.auto.IInjectorService,
        public qpMessageDialog: IMessageDialog,
        public $translate: angular.translate.ITranslateService,
    ) {
        super($objectTree, anonymousRestService);
        this.action = "login";
        this.rootPath = this.pageContext.rootPath;
        // 用户隐私权限声明
        this.privacy = false;
        // 本地缓存--用户隐私权限
        this.cachePrivacyPolicy = false;
    }

    public $onInit() {
        this.initGoogle();
        // 页面跳转监听
        this.$scope.$parent.$on("socialLoginOpen", (event: angular.IAngularEvent, jumpParams: jumpParams) => {
            if (jumpParams) {
                this.jumpPath = jumpParams.prePath;
            }
        })
        // this.initFacebook();

    }

    public goToHomePage() {
        window.location.href = this.rootPath + 'index.html';
    }

    public goToDashboard() {
        window.location.href = UrlUtil.joinUrl([this.rootPath, "/dashboard/"]);
    }

    public goToJumpPage() {
        if (this.jumpPath) {
            window.location.href = this.jumpPath;
        }
    }

    public jumpToSpecifyPage() {
        if (this.jumpPath) {
            this.goToJumpPage();
        } else {
            this.goToDashboard();
        }
    }

    public initGoogle() {
        const CLIENT_ID = envConfig.googleOAuth2ClientId;

        window.onGoogleLibraryLoad = () => {
            if (window.google) {
                const tokenClient = window.google.accounts.oauth2.initTokenClient({
                    client_id: CLIENT_ID,
                    scope: "email profile openid",
                    callback: this.googleSignInCallback.bind(this),
                    error_callback: this.googleSignInErrorCalllBack.bind(this)
                });
                this.tokenClient = tokenClient;
            }
        }
    }

    public signInWithSocialNetwork(socialNetwork: string) {
        if (socialNetwork.toLowerCase() == "google") {
            this.signInWithGoogle();
        } else if (socialNetwork.toLowerCase() == "facebook") {
            this.signInWithFacebook();
        } else {
            console.warn("Social network is not exist!");
        }
    }

    public signInWithGoogle() {
        if (this.tokenClient) {
            this.tokenClient.requestAccessToken();
        } else {
            this.qpMessageDialog.warning({
                title: this.$translate.instant('CONNECTION_GOOGLE_FAIL_TITLE'),
                content: this.$translate.instant('CONNECTION_GOOGLE_FAIL_CONTENT')
            })
        }
    }

    public googleLogout() {

    }

    public googleSignInCallback(res: google.accounts.oauth2.TokenResponse) {
        if (res) {
            this.socialNetwork = "google";
            this.thirdAccessToken = res.access_token;
            // google response token校验接口
            this.socialLoginRestService.login(res.access_token, this.socialNetwork.toLowerCase() as thirdOAuthType).then(res => {
                if (res.success) {
                    if (res.data.needRegister) {
                        // token验证成功且该账号未关联
                        this.$timeout(() => {
                            this.socialUserNickname = res.data.username;
                            this.socialUserEmail = res.data.email;

                            this.action = "regist";
                            this.$scope.$parent.$emit("socialNetworkLogin", {
                                nickName: res.data.username,
                                email: res.data.email,
                                socialNetwork: this.socialNetwork,
                                action: this.action
                            })
                        })
                    } else {
                        this.action = "login";
                        // 获取登录前的匿名用户ID
                        const anonymousUserId = this.$objectTree.getAnonymousUserId() || 0;
                        // todo: objectTree 赋值、匿名用户合并购物车
                        this.$objectTree.setLogin({
                            isAnonymous: false,
                            firstName: res.data.token.firstName!,
                            userName: res.data.token.username!,
                            token: res.data.token.access_token!,
                            tokenType: res.data.token.token_type!,
                            partnerType: res.data.token.partnerType!,
                            anonymousUserId: String(anonymousUserId)
                        })

                        // 初始化登录信息
                        // todo: cartRestService旧接口替换后去除
                        this.runtimeContext.initRuntimeContext();

                        // 将匿名用户购物车信息合并至登录后的用户信息中
                        if (anonymousUserId != 0) {
                            // todo: cartRestService旧接口替换
                            this.cartRestService.mergeCart(anonymousUserId).then(cartResp => {
                                // if (!cartResp) {
                                //     return;
                                // }
                                this.jumpToSpecifyPage();
                            }).catch(reason => {
                                // 错误处理
                            }).finally(() => {
                                this.jumpToSpecifyPage();
                            });
                        } else {
                            this.jumpToSpecifyPage();
                        }
                    }
                }
            }, reason => {
                // todo: 错误码
                this.onRequestFail(reason);
            })
        }
    }

    public googleSignInErrorCalllBack() {

    }

    /*************************************** Facebook ************************************************/
    public initFacebook() {
        const APP_ID = "982380922789279";

        window.fbAsyncInit = function () {
            // jsonp params: #xfbml=1&version=v17.0&appId=${APP_ID}&autoLogAppEvents=1
            if (window.FB) {
                window.FB.init({
                    appId: APP_ID,
                    // Enable cookies to allow the server to access the session.
                    cookie: true,
                    // Use this Graph API version for this call.
                    version: 'v7.0',
                });
            }
        }
    }

    public signInWithFacebook() {
        if (window.FB) {
            // static.cdn.pf.com
            window.FB.getLoginStatus((res) => {
                const fbUser: fbUser = {
                    isUserLoggedIn: false,
                    token: "",
                    userId: ""
                };
                this.socialNetwork = "facebook";
                if (res.authResponse) {
                    fbUser.isUserLoggedIn = true;
                    fbUser.token = res.authResponse.accessToken;
                    fbUser.userId = res.authResponse.userID;
                } else {
                    fbUser.isUserLoggedIn = false;

                    window.FB.login((res) => {

                    })
                }
            }, true);
        }
    }

    public facebookLogout(token) {
        if (window.FB) {
            window.FB.logout(token);
        }
    }

    /*************************************** other Login ************************************************/


    /*************************************** Sign up ************************************************/
    public socialSignUp() {
        if (this.$scope["socialRegisterForm"].$valid) {
            this.isSignUping = true;
            this.socialLoginRestService.register({
                email: this.socialUserEmail!,
                // username作为queryString参数传递，若username中有#等符号，会导致请求错误（所以需要encode）
                username: window.encodeURIComponent(this.socialUserNickname!),
                thirdOAuthType: this.socialNetwork,
                thirdAccessToken: this.thirdAccessToken
            }).then(res => {
                if (res.success) {
                    // 用户隐私权限设置
                    this.$objectTree.setCache('PrivacyPolicy', String(this.cachePrivacyPolicy));
                    const anonymousUserIdCache = this.$objectTree.getCache("AnonymousUserId");
                    this.isSignUping = false;
                    // objectTree 赋值
                    this.$objectTree.setLogin({
                        isAnonymous: false,
                        firstName: res.data.token.firstName!,
                        userName: res.data.token.username!,
                        token: res.data.token.access_token!,
                        tokenType: res.data.token.token_type!,
                        partnerType: res.data.token.partnerType!
                    })

                    const anonymousUserId = anonymousUserIdCache ? Number(anonymousUserIdCache) : 0;
                    // 初始化登录信息
                    // todo: cartRestService旧接口替换后去除
                    this.runtimeContext.initRuntimeContext();

                    // 将匿名用户购物车信息合并至登录后的用户信息中
                    if (anonymousUserId != 0) {
                        // todo: cartRestService旧接口替换
                        this.cartRestService.mergeCart(anonymousUserId).then(cartResp => {
                            // if (!cartResp) {
                            //     return;
                            // }
                            this.jumpToSpecifyPage();
                        }).catch(reason => {
                            // 错误处理
                        }).finally(() => {
                            this.jumpToSpecifyPage();
                        });
                    } else {
                        this.jumpToSpecifyPage();
                    }
                }
            }, reason => {
                // code=5220012, message=A partner with email:${email} already exists
            }).finally(() => {
                this.isSignUping = false;
            })
        }
    }
}